import { Injectable } from '@angular/core';
import { MicrosoftAuthBaseService } from './microsoft-auth-base.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { LoginService } from './login.service';
import { filter } from 'rxjs';
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root',
})
export class MicrosoftAuthMsalService implements MicrosoftAuthBaseService{
  
   
 private initialized = false;
  private redirectUsername: string | null = null;

  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {}

  async initialize(): Promise<string | null> {
    if (this.initialized) {
      return this.redirectUsername;
    }

    await this.msalService.instance.initialize();

    const result: AuthenticationResult | null =
      await this.msalService.instance.handleRedirectPromise();

    if (result?.account) {
      this.msalService.instance.setActiveAccount(result.account);
      this.redirectUsername = result.account.username || null;
    } else {
      const activeAccount =
        this.msalService.instance.getActiveAccount();

      this.redirectUsername =
        activeAccount?.username || null;
    }

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (message: EventMessage) =>
            message.eventType === EventType.LOGOUT_FAILURE
        )
      )
      .subscribe((message: EventMessage) => {
        console.error(
          'Microsoft logout failed:',
          message.error
        );
      });

    this.initialized = true;

    return this.redirectUsername;
  }

  async loginMicrosoft(): Promise<void> {
    await this.initialize();
    await this.msalService.loginRedirect();
  }

  async logoutMicrosoft(): Promise<void> {
    const activeAccount =
      this.msalService.instance.getActiveAccount();

    await this.msalService.logoutRedirect({
      account: activeAccount ?? undefined,
      postLogoutRedirectUri: window.location.origin
    });
  }

  isLoggedIn(): boolean {
    return (
      this.msalService.instance.getActiveAccount() !== null
    );
  }
}
